import { styled } from 'styled-components';
import { breakpoint, spacing } from 'styles/helpers';
import { theme } from 'styles/theme';

export const Container = styled.div`
    background-color: ${theme.colors.highlight};
    border-radius: 4px;
    column-gap: ${spacing.xs};
    display: grid;
    grid-template-columns: min-content 1fr;
    grid-template-rows: auto auto;
    height: fit-content;
    padding: ${spacing.s};
    
    & > * {
        padding-bottom: 4px;
    }

    ${breakpoint.mobile} {
        display: flex;
        flex-direction: column;
    }
`;

export const DisclaimerTitleWrapper = styled.div`
    ${theme.typography.h7};
    grid-column: 2 / 3;
    padding-top: 4px;
`;

export const DisclaimerTitleIconWrapper = styled.div`
    color: ${theme.colors.primary};
    grid-column: 1 / 2;

    & > * {
        height: 24px;
        width: 24px;
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spacing.s};
    grid-column: 2 / 2;
`;
